import styled, {css} from "styled-components";
import {ModalProps, ModalSize} from "./index";

export const Modal = styled.div`
  z-index: 300;
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  display: flex;
  background-color: rgba(0, 0, 0, 0.5);
  justify-content: center;
  align-items: center;
`

export const Content = styled.div<{modalSize: ModalSize}>`
  background: #FFFFFF;
  width: 100%;
  height: 100vh;
  border-radius: 0;
  border: none;
  position: absolute;
  top: 0;

  @media only screen and (${({theme}) => theme.media.small}) {
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 40px;
    position: relative;
    height: auto;

    ${({modalSize}) => {
      switch (modalSize) {
        case ModalSize.large:
          return css`width: 80%;`
        case ModalSize.medium:
          return css`width: 55%;`
        case ModalSize.small:
          return css`width: 35%;`
      }}};
  }
`

export const Body = styled.div`
  overflow-y: scroll;
  scrollbar-width: none; /* for Internet Explorer, Edge */
  -ms-overflow-style: none;  /* for Firefox */
  height: 100%;
  max-height: 80vh;
  padding: 0 2rem;
  
  &::-webkit-scrollbar {
    display: none; /* for Chrome, Safari, and Opera */
  }

  @media only screen and (${({theme}) => theme.media.small}) {
    padding: 2rem;
  }
`
